import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { VerifyAdminAccess } from "../AdminServices/AdminLoginService";

const AdminProtectedRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      const result = await VerifyAdminAccess();
      setIsAdmin(result?.isAdmin === true);
      setLoading(false);
    };

    checkAdmin();
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p>Checking admin access...</p>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
